export var base = `<div id="header"></div>

<main id="subapp-container" class="subapp-container-without-token" ></main>`;

  export function setBaseWithoutToken() {
    document.getElementById("base").innerHTML = base;
  }

